// libs
import styled from "@emotion/styled";
import { css } from "@emotion/core";

// components
import Button from "shared/components/Button";

// constants
import { FONTS, BASE_GUTTER_SPACE, COLORS, BREAKPOINTS } from "shared/styles/base";

// styles
export const Actions = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-content: center;
`;

export const Info = styled.p`
    font: 400 1.1429rem/1.5 ${FONTS.CERA};
    letter-spacing: 0.25px;
    color: ${COLORS.BLACK_92};
    margin: 0 0 20px 0;
`;

export const Heading = styled.h3`
    font: 700 1.7143rem/1.33 ${FONTS.CERA};
    letter-spacing: 0.25px;
    color: ${COLORS.BLACK_92};
    margin: 0 0 ${BASE_GUTTER_SPACE}px 0;
`;

export const SubmitButton = styled(Button)`
    margin-right: ${BASE_GUTTER_SPACE}px;
    white-space: nowrap;
    padding: 0 ${BASE_GUTTER_SPACE * 4}px;
`;

export const LaterButton = styled(Button)`
    background: transparent;
    border: solid 1px ${COLORS.BLACK_16};
    color: ${COLORS.BLACK_100};
`;

export const OverlaySheetCss = css`
    height: auto;
    width: 100%;
    background-color: white;
    top: initial;
    padding: ${BASE_GUTTER_SPACE * 4}px 20px 20px 20px;
    border-radius: 16px 16px 0 0;
    box-shadow: 0 -4px 16px 0 rgba(0, 0, 0, 0.16);

    @media screen and (min-width: ${BREAKPOINTS.MOBILE}px) {
        width: 360px;
        left: calc(100% - 360px);
    }
`;
